/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch } from 'react-redux'
import PropTypes, { object } from 'prop-types';
import clsx from "clsx";
import XLSX from "sheetjs-style";
import { useHistory, Link } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@material-ui/core';
import { MdReplay } from 'react-icons/md';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { MESSAGE_TYPE, RESOURCE_TYPE } from '../../constants'
import ReportTable from '../ReportTableComponent/ReportTable';
import { setLogin } from '../../redux/features/auth/actions';
import {
  CustomFormGroup,
} from "../FormComponents";
import { Button } from "../../atomicComponents";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import styles from "./UnallocatedOperatorReport.module.css";
import { withAllowedOperationsProvider } from '../../hocs';
import Truckloading from "../CvLoader/Cvloader";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from '../../utils/utils';


const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "0.7em",
        height: "0.7em",
      },
    },
  })
);

function UnallocatedOperatorReport({auth,baseUrl}) {
  const classes = useStyles();
  const { showPopup } = usePopupManager();
  const history = useHistory();
  const dispatch = useDispatch();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const handleClose = () => setIsPopupOpen(false);
  const [typeOfReport, setTypeOfReport] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [asnCount, setAsnCount] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const SupervisorFlag=auth.userRole.includes("S");
  const SuperAdminFlag=auth.userRole.includes("SA");
  const DSFlag=auth.userRole.includes("DS")
  const  userList=['SA','S','DS']
  const filterData=auth?.userRole?.filter((data)=> userList?.includes(data))
  const[filterList,setFilterList]=useState(filterData)
  const HEIGHT = '300px';
  const FILENAME = 'Un-Allocated_Operator_Report';

  useEffect(() => {
    setViewDisplay(true);
  }, []);

    const baseDefaultColumns = [
      {
        width: 80,
        title: 'BC No',
        field: 'bc_no',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 220,
        title: 'BC Description',
        field: 'cost_center_desc',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 100,
        title: 'Employee Ticket No',
        field: 'pers_no',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 140,
        title: 'Employee Name ',
        field: 'complete_name',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 100,
        title: 'Location ',
        field: 'location',
        enableSearch: true,
        enableFilter: true,
      },
      ];

      const resetFields = () => {
        setBcName(null);
        setBu(null);
        setBarrel(null);
        setProjDescp(null);
    
      }
 
  const setCount = (count) => {
    setAsnCount(count);
  };

  const newKeySequence = [
    'id',
    "bc_no",
    "complete_name",
    "location",
    "pers_no",
    "cost_center_desc",
];

  function changeKeySequence(data, keySequence) {
    return data.map((dict) => {
      const newDict = {};
      keySequence.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(dict, key)) {
          newDict[key] = dict[key];
        }
      });
      return newDict;
    });
  }
  

  function downloadExcel(data) {
    const modifiedList = changeKeySequence(data, newKeySequence);
   
  const columnsKeys = {
          'id': 'Id',
          'bc_no':'BC No',
          'cost_center_desc':'BC Description', 
          'pers_no':'Employee Ticket No',
         'complete_name':'Employee Name',
         'location':'Location',
        }
    modifiedList.forEach((item, index) => {item.id = index + 1;});
    const updateExportData = modifiedList.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'SPOCReport.xlsx');
  }
  

  useEffect(()=>{
    if(typeOfReport !==''){
      getUnallocated(typeOfReport)
    }
  },[typeOfReport])

  useEffect(()=>{
    if(filterList){
      let filterDataString=filterList.toString();
      if(filterList?.length==1){
        getUnallocated(filterDataString)
      } 
    }
  },[filterList])

  const getUnallocated=(typeOfReports)=>{
    try{
     setLoading(true)
      const apiFormatedData = 
      {
      "pers_no":sanitizeNumeric(auth.personNumber),
      "co_code":sanitizeCoCodeNumeric(auth.companyCode),
      "cost_center": auth.costCenter,
      "user_role":typeOfReports,
      "location" :auth.location
      }
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    fetch(`${baseUrl}reports/UnallocatedOperativeReport`,
      {
        method: 'POST',
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson
      })
      .then((response) => {
       
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          setLoading(false)
          if(responseJson?.data?.length > 0 && responseJson.msg=='Success'){
            const finalData=[];
             responseJson.data.map((row,index)=>{
               finalData.push({
              id:index,
              ...row,
            })
             })
            setTableData(finalData)
          }
          else if(responseJson.msg=="Fail"){
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: responseJson.data,
            }); 
            setTableData([])
          }
          else if(responseJson?.data?.length==0){
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: 'No Records Found',
            });
            setTableData([])
          }
      }
      })
    }
    catch(error){
      setTableData([])
      setLoading(false)
      if (error.response) {
        showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Oops! Something went wrong. Please try again later. Please try again later",
            })
      }
      else {
        showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "There might be Network issue, please try after some time",
          })
      }
    }
  }


  const renderTable = () => (
    <div
      className={styles.formGroup}
    >
      <div     
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px"
        }}
      >       
            <>  
                <ReportTable columns={baseDefaultColumns} data={tableData} height={HEIGHT} fileName={FILENAME}/>         
        </>
        
      </div>

    </div>
  );

  const renderOptions = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}
            value={typeOfReport}
            onChange={(event) => setTypeOfReport(event.target.value)}
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
          >
            {SuperAdminFlag && 
              <FormControlLabel
              value="SA"
              name="SA"
              control={<Radio size="small" />}
              style={{ color: "black" }}
              className={styles.radiobtn}
              label="Super Admin"
            />
            }
            {DSFlag && 
             <FormControlLabel
             value="DS"
             name="DS"
             control={<Radio size="small" />}
             label="Departmental SPOC"
             style={{ color: "black" }}
             className={styles.radiobtn}
           />
            }
            {SupervisorFlag && 
             <FormControlLabel
             value="S"
             name="S"
             control={<Radio size="small" />}
             label="Supervisor"
             style={{ color: "black" }}
             className={styles.radiobtn}
           />
            }
          </RadioGroup>
        </Grid>
      </Grid>
    </div>
  );

 
  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.formContainer
        )}
      >
        <CustomFormGroup header="Un-Allocated Operator Report" />
        {filterData?.length > 1 && renderOptions()}
        {
          tableData?.length !== 0 && 
          renderTable()
        }
        {loading ? (
        <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
             <Truckloading />
          </div>):""}
      </div>
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />
    </>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            {/* <DeleteIcon style={{ height: '18px', width: '18px' }} /> */}
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
UnallocatedOperatorReport.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
UnallocatedOperatorReport.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(UnallocatedOperatorReport);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);